"use strict";

module.exports = function () {
  return this.opts.filterByColumn ? JSON.stringify(this.query) : this.query;
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/computed/q.js